import React, { useCallback, useState } from 'react';
import { Form, Input, Button, Modal, Image } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useConnection } from '@sezenta/connection';
import { setFormValidationErrors } from '../../common/Utils';
import GoogleLoginButton from '../../login/GoogleLoginButton';
import { ArrowRightOutlined } from '@ant-design/icons';
import {
  decodeJwt,
  getLoginContractHint,
  isSuperAdmin,
} from '../../context/ContractHelpers';

const LoginForm2 = () => {
  const [form] = Form.useForm();
  const [submittable, setSubmittable] = React.useState<boolean>(false);
  const values = Form.useWatch([], form);
  const navigate = useNavigate();
  const connection = useConnection();
  const [loading, setLoading] = useState<boolean>(false);

  React.useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, values]);

  const handleSubmit = useCallback(
    async (values: any) => {
      setLoading(true);
      try {
        const res = await connection.post(
          `auth/login/${getLoginContractHint()}`,
          values,
        );
        const accessToken = res.data.tokens.accessToken;
        connection.login(accessToken, res.data.tokens.refreshToken);
        // CR004: route by role. Super-admin → admin shell; everyone else → the
        // Select-Contract hub, which auto-enters when there's only one contract.
        const payload = decodeJwt(accessToken);
        navigate(
          isSuperAdmin(payload) ? '/admin/projects' : '/select-contract',
        );
      } catch (error: any) {
        // Only login validation errors carry an axios `.response`; guard against
        // network/CORS errors (no response) that would crash the helper.
        if (!error?.response?.data || !setFormValidationErrors(form, error)) {
          Modal.error({
            title: 'Login Failed',
            content:
              'You are not authorized to access this page. Please check your credentials and try again.',
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [connection, form, navigate],
  );

  return (
    <div className="login-form grid place-items-center h-screen w-screen">
      <div
        className="bg-white  w-[1300px] h-[800px] flex border-8"
        style={{ boxShadow: '0px 6px 28px 2px rgba(0, 0, 0, 0.12)' }}
      >
        <div className="flex flex-col w-[50%] h-full  py-6 px-6 pl-32">
          <div className="w-full flex justify-start items-center">
            <Image
              src={'/img/logo.png'}
              preview={false}
              width={151}
              height={64}
            />
          </div>
          <div className="flex flex-1  flex-col justify-center items-start gap-4">
            <div className="w-full flex flex-col justify-start items-start">
              <h1 className="text-[32px] font-medium leading-[40px] text-center font-inter font-[#18191C]">
                Sign in
              </h1>
              <p className="text-[16px] font-normal leading-[24px] tracking-[0%] text-center text-[#5E6870] mt-2 font-inter">
                Please login into your account
              </p>
            </div>
            <div className="w-full">
              <Form
                form={form}
                name="login"
                className="flex flex-col w-full gap-1"
                onFinish={handleSubmit}
              >
                <div>
                  <Form.Item
                    name="userName"
                    className="h-[48px]"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your username!',
                      },
                    ]}
                  >
                    <Input placeholder="User Name" />
                  </Form.Item>
                </div>
                <div>
                  <div className="flex justify-between">
                    {/*<a*/}
                    {/*  href="/forget-password"*/}
                    {/*  className="text-primary-base font-semibold no-underline"*/}
                    {/*>*/}
                    {/*  Forgot Password*/}
                    {/*</a>*/}
                  </div>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your password!',
                      },
                    ]}
                  >
                    <Input.Password placeholder="Password" />
                  </Form.Item>
                </div>
                <div className="flex flex-col mt-0">
                  <Form.Item>
                    <Button
                      loading={loading}
                      disabled={loading || !submittable}
                      type="primary"
                      htmlType="submit"
                      className="w-full mt-1 bg-primary text-white h-[53px] rounded-[2px] text-base font-semibold font-inter"
                      style={{
                        height: '53px',
                        borderRadius: '4px',
                        fontSize: '16px',
                        fontWeight: 600,
                        fontFamily: 'Inter',
                      }}
                    >
                      <div className="flex items-center justify-center gap-4">
                        <span>Sign In</span>
                        <ArrowRightOutlined style={{ fontSize: '18px' }} />
                      </div>
                    </Button>
                  </Form.Item>
                </div>
                {/*<p className="flex items-center justify-center mt-1 gap-1">*/}
                {/*  <span className="w-[40px] border border-gray-300 border-solid"></span>*/}
                {/*  <span className="text-gray-500 ml-1">or Login with</span>*/}
                {/*  <span className="w-[40px] border border-gray-300 mt-1 border-solid ml-[4px]"></span>*/}
                {/*</p>*/}
                {/*<GoogleLoginButton />*/}
              </Form>
            </div>
          </div>
        </div>
        <div
          className="w-[50%] h-full overflow-hidden animate-bg-motion flex items-end px-[60px] pb-9"
          style={{
            backgroundImage: "url('/img/login-side-new.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <span className="text-xl  font-inter text-white">
            Over 30+ Million kg of unwanted textiles are collected thought our
            services and programs each year.
          </span>
        </div>
      </div>
    </div>
  );
};

export default LoginForm2;
